import { Component, Input } from '@angular/core';

@Component({
    selector: 'sb-card-section',
    templateUrl: './sb-card-section.component.html',
    styleUrls: ['./sb-card-section.component.scss']
})
export class SbCardSectionComponent {
    @Input() title: string;
    @Input() description: string;
    @Input() sectionClasses: string;
    @Input() h3Class: string;
    @Input() h5Class: string;
    @Input() cardBodyClasses: string;
    @Input() isPrintMode: boolean;
    @Input() headerClasses: string;
    @Input() descriptionClasses: string;
}
